<oaibox-top-bar>
  @if (!isUnprivilegedSales) {
    <li class="top-bar-item">
      <a class="top-bar-link" [class.selected]="currentRoute === AvailableRoutes.DEPLOYMENTS"
         [routerLink]="deploymentsListUrl?.toString()">Deployments</a>
      @if (client) {
        <i class="path-icon fa-solid fa-caret-down white"></i>
      }
      @if (!client && currentRoute === AvailableRoutes.NEW_DEPLOYMENT) {
        <i class="path-icon fa-solid fa-caret-down white"></i>
      }
    </li>

    @if (currentRoute === AvailableRoutes.NEW_DEPLOYMENT) {
      <li class="top-bar-item">
        <div class="top-bar-link selected">New Deployment</div>
      </li>
    }

    @if (client) {
      <li class="top-bar-item client">
        <div class="top-bar-link middle-button ellipsis">
          <div class="ellipsis">
            <div class="ellipsis">
              {{ client.clientName }}
            </div>
            <div class="under-label ellipsis">
              {{ client.clientDescription }}
            </div>
          </div>
        </div>
        <i class="path-icon fa-solid fa-caret-down white"></i>
      </li>
    }

    @if (currentRoute === AvailableRoutes.GNB_CUSTOM_CONFIGURATION) {
      <li class="top-bar-item">
        <div class="top-bar-link selected">gNB Custom Configuration</div>
      </li>
    }
    @else if (currentRoute === AvailableRoutes.UPDATE_DEPLOYMENT) {
      <li class="top-bar-item">
        <div class="top-bar-link selected">Update Deployment</div>
      </li>
    }
  }

  <li class="top-bar-item" [oaiboxAuthorizedRoles]="[UserRole.SALES]">
    <a class="top-bar-link" [class.selected]="currentRoute === AvailableRoutes.LICENSES"
       [routerLink]="licensesUrl?.toString()">Licenses</a>
  </li>

  <li class="top-bar-item" [oaiboxAuthorizedRoles]="[UserRole.ROOT]">
    <a class="top-bar-link" [class.selected]="currentRoute === AvailableRoutes.OPERATIONS"
       [routerLink]="operationsUrl?.toString()">Operations</a>
  </li>

  <li class="top-bar-item" [oaiboxAuthorizedRoles]="[UserRole.ROOT]">
    <a class="top-bar-link" [class.selected]="currentRoute === AvailableRoutes.ORDERS"
       [routerLink]="ordersUrl?.toString()">Orders</a>
  </li>

  @if (!isUnprivilegedSales) {
    <li class="top-bar-item" [oaiboxAuthorizedRoles]="[UserRole.ROOT]">
      <a class="top-bar-link" [class.selected]="currentRoute === AvailableRoutes.RELEASES"
         [routerLink]="releasesUrl?.toString()">Releases</a>
      @if (currentRoute === AvailableRoutes.NEW_RELEASE) {
        <i class="path-icon fa-solid fa-caret-down white"></i>
      }
    </li>

    @if (currentRoute === AvailableRoutes.NEW_RELEASE) {
      <li class="top-bar-item" [oaiboxAuthorizedRoles]="[UserRole.ROOT]">
        <div class="top-bar-link selected">New Release</div>
      </li>
    }

    <div class="right-buttons">
      <li class="top-bar-item" [oaiboxAuthorizedRoles]="[UserRole.ADMIN]">
        <a class="top-bar-link" [class.selected]="currentRoute === AvailableRoutes.GNB_DEFAULT_CONFIGURATION"
           [routerLink]="gnbDefaultConfigurationUrl?.toString()">RAN Default Configuration</a>
      </li>
      <li class="top-bar-item" [oaiboxAuthorizedRoles]="[UserRole.ROOT]">
        <a class="top-bar-link" [class.selected]="currentRoute === AvailableRoutes.USERS"
           [routerLink]="usersUrl?.toString()">Users</a>
      </li>

      @if (currentRoute === AvailableRoutes.NEW_USER) {
        <li class="top-bar-item" [oaiboxAuthorizedRoles]="[UserRole.ROOT]">
        <a class="top-bar-link" [class.selected]="currentRoute === AvailableRoutes.NEW_USER"
           [routerLink]="usersUrl?.toString()">New User</a>
      </li>
      }
      <li class="top-bar-item" [oaiboxAuthorizedRoles]="[UserRole.STOCK_MANAGEMENT_PAGE]">
        <a class="top-bar-link" [class.selected]="currentRoute === AvailableRoutes.STOCK_MACHINES"
           [routerLink]="machinesUrl?.toString()">Machines</a>
      </li>
    </div>
  }
  <oaibox-keycloak-profile profile></oaibox-keycloak-profile>
</oaibox-top-bar>

<router-outlet></router-outlet>
